/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "24347642f2fb468896bc953af0665f73",
    "aws_mobile_analytics_app_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:ba4dd1f4-25bb-4385-934e-60dfa4111fd4",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Qk9mEbZgy",
    "aws_user_pools_web_client_id": "97j7tdtv8l5ui2s3705g9fbj5",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "violett-dashboard-userfile162811-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
